import { render, staticRenderFns } from "./AttachMessage.vue?vue&type=template&id=d2e21bde&scoped=true&lang=pug"
import script from "./AttachMessage.vue?vue&type=script&lang=js"
export * from "./AttachMessage.vue?vue&type=script&lang=js"
import style0 from "./AttachMessage.vue?vue&type=style&index=0&id=d2e21bde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e21bde",
  null
  
)

export default component.exports